// extracted by mini-css-extract-plugin
export default {"container":"OA-z","dimension":"PA-z","dimensionLabels":"QA-z"};